import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

interface Props {
  title: string;
  depositPaid: string;
  purchasePrice: string;
  buyerName: string;
  plotNumber: string;
}

const formatPrice = (price: string): string => {
  const numericPrice = parseFloat(price);
  if (isNaN(numericPrice)) return price;

  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(numericPrice);
};

const DevelopmentUpdatesViewHeader = ({
  title,
  depositPaid,
  purchasePrice,
  buyerName,
  plotNumber,
}: Props) => {
  const { ref, inView } = useInView({ threshold: 0.2 });

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className="flex flex-col mb-[3.5rem] overflow-hidden"
    >
      <motion.h1
        initial={{ opacity: 0, clipPath: "inset(0 100% 0 0)" }}
        animate={
          inView
            ? { opacity: 1, clipPath: "inset(0 0 0 0)" }
            : { opacity: 0, clipPath: "inset(0 100% 0 0)" }
        }
        transition={{ duration: 0.7, delay: 0.3 }}
        className="h5 text-white mb-[2rem]"
      >
        {title}
      </motion.h1>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.7, delay: 0.4 }}
        className="flex flex-col gap-2 text-white"
      >
        <motion.h4
          initial={{ opacity: 0, clipPath: "inset(0 0 0 100%)" }}
          animate={
            inView
              ? { opacity: 1, clipPath: "inset(0 0 0 0)" }
              : { opacity: 0, clipPath: "inset(0 0 0 100%)" }
          }
          transition={{ duration: 0.7, delay: 0.5 }}
        >
          Purchase Price: {formatPrice(purchasePrice)}
        </motion.h4>
        <motion.h4
          initial={{ opacity: 0, clipPath: "inset(0 0 0 100%)" }}
          animate={
            inView
              ? { opacity: 1, clipPath: "inset(0 0 0 0)" }
              : { opacity: 0, clipPath: "inset(0 0 0 100%)" }
          }
          transition={{ duration: 0.7, delay: 0.6 }}
        >
          Deposit Paid: {formatPrice(depositPaid)}
        </motion.h4>
        <motion.p
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.7, delay: 0.7 }}
          className="text-white/80"
        >
          Buyer: {buyerName} | Plot Number: {plotNumber}
        </motion.p>
      </motion.div>
    </motion.div>
  );
};

export default DevelopmentUpdatesViewHeader;

